



























metaMixin = require '@/mixins/meta'

import Marquee from '@/components/Marquee'
import GameCards from '@/components/GameCards'
import Reviews from '@/components/Reviews'
import Footer from '@/components/Footer'
import Laurels from '@/components/Laurels'

import { throttle, forEachRight } from 'lodash'
import $ from 'jquery'

$win = $(window)

export default {
  name: 'home-page',

  mixins: [metaMixin]

  components: 
    marquee: Marquee 
    'game-cards': GameCards 
    laurels: Laurels 
    reviews: Reviews 
    'lucre-footer': Footer 

  data: -> 
    activeGradient: 0
    meta: 
      title: 'GeoTap Game for iOS and Android'
      description: 'A subtly addictive stress-relief game'
      image: 'http://geotapgame.com/static/geotap-game-lucre-games-lowpoly-3d-casual-relaxing-mobile-game.png'
      route: '/'

    unlockableImg: require '@/assets/images/geotap-game-mobile-unlockable-low-poly-shapes.png'

  watch: 
    '$parent.ready': (nv,ov) ->
      @onScroll()

  mounted: -> 
    @gradientAreas = $(@$el).find('.gradient-area')
    $win.on 'scroll', throttle(@onScroll,50)
    
  destroyed: -> $win.off 'scroll'

  methods: 
    onScroll:(e) -> 
      pos = ($win.scrollTop() + ($win.outerHeight()*.7))
      for g in @gradientAreas.get().reverse()
        i = @gradientAreas.index(g)
        if pos >= $(g).offset().top
          @activeGradient = i
          return false

      # Defualt to the first gradient as a backup
      @activeGradient = 0
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Home.vue